// QuotationManagementTableMobile.js
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiEye, FiEdit, FiTrash2, FiCopy } from "react-icons/fi";
import {
  canEditDelete,
  isLevelOneViewingOtherQuotation,
} from "../utils/buttonVisibility";

const QuotationManagementTableMobile = ({
  quotations,
  handleDelete,
  handleDuplicate,
}) => {
  const navigate = useNavigate();

  const getStatusStyle = (status) => {
    switch (status) {
      case "Approved":
        return "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300";
      case "Pending":
        return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300";
      case "Rejected":
        return "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300";
      case "Canceled":
        return "bg-gray-200 text-gray-800 dark:bg-gray-800 dark:text-gray-300";
      default:
        return "bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300";
    }
  };

  return (
    <div className="space-y-4 md:hidden transition-colors duration-300">
      {quotations.map((q) => {
        const isViewOnly = isLevelOneViewingOtherQuotation(q);

        return (
          <div
          key={q._id}
          className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700
                     p-4 rounded-lg shadow-sm transition-colors duration-300"
        >
          <div className="mb-3 space-y-1 text-sm text-gray-800 dark:text-gray-200">

            <p>
              <span className="font-semibold text-gray-900 dark:text-blue-400">
                Run Number:
              </span>{" "}
              {q.runNumber || "-"}
            </p>

            <p>
              <span className="font-semibold text-gray-900 dark:text-blue-400">
                Type:
              </span>{" "}
              {q.type || "-"}
            </p>

            <p>
              <span className="font-semibold text-gray-900 dark:text-blue-400">
                Title:
              </span>{" "}
              {q.title || "-"}
            </p>

            <p>
              <span className="font-semibold text-gray-900 dark:text-blue-400">
                Client:
              </span>{" "}
              {q.client || "N/A"}
            </p>

            <p>
              <span className="font-semibold text-gray-900 dark:text-blue-400">
                Date:
              </span>{" "}
              {q.documentDate
                ? new Date(q.documentDate).toLocaleDateString("th-TH", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : "-"}
            </p>

            {/* ⭐ Total Before VAT */}
            <p>
              <span className="font-semibold text-gray-900 dark:text-blue-400">
                Total Before VAT:
              </span>{" "}
              {q.total
                ? q.total.toLocaleString("th-TH", {
                    style: "currency",
                    currency: "THB",
                  })
                : "-"}
            </p>

            {/* ⭐ Net Amount */}
            <p>
              <span className="font-semibold text-gray-900 dark:text-blue-400">
                Net Amount:
              </span>{" "}
              {q.netAmount
                ? q.netAmount.toLocaleString("th-TH", {
                    style: "currency",
                    currency: "THB",
                  })
                : "-"}
            </p>

            {/* STATUS */}
            <p>
              <span className="font-semibold text-gray-900 dark:text-blue-400">
                Status:
              </span>{" "}
              <span
                className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusStyle(
                  q.approvalStatus
                )}`}
              >
                {q.approvalStatus}
              </span>
            </p>

            {/* CREATED BY */}
            <p>
              <span className="font-semibold text-gray-900 dark:text-blue-400">
                Created By:
              </span>{" "}
              {q.createdByUser ? q.createdByUser.split("@")[0] : "-"}
            </p>
          </div>

          {/* ACTION BUTTONS */}
          <div className="flex flex-wrap gap-2">
            <Link
              to={`/quotations/${q._id}`}
              className="p-2 rounded-md bg-blue-100 text-blue-700 hover:bg-blue-200
                         dark:bg-blue-900/40 dark:text-blue-300 dark:hover:bg-blue-800/60 transition-colors"
              title="View"
            >
              <FiEye size={16} />
            </Link>

            {!isViewOnly &&
              q.approvalStatus !== "Canceled" &&
              q.approvalStatus !== "Draft" && (
                <button
                  onClick={() => handleDuplicate(q)}
                  className="p-2 rounded-md bg-purple-100 text-purple-700 hover:bg-purple-200
                             dark:bg-purple-900/40 dark:text-purple-300 dark:hover:bg-purple-800/60 transition-colors"
                  title="Duplicate"
                >
                  <FiCopy size={16} />
                </button>
              )}

            {!isViewOnly && canEditDelete(q.approvalStatus) && (
              <>
                <button
                  onClick={() => navigate(`/quotations/edit/${q._id}`)}
                  className="p-2 rounded-md bg-yellow-100 text-yellow-700 hover:bg-yellow-200
                             dark:bg-yellow-900/40 dark:text-yellow-300 dark:hover:bg-yellow-800/60 transition-colors"
                  title="Edit"
                >
                  <FiEdit size={16} />
                </button>

                <button
                  onClick={() => handleDelete(q)}
                  className="p-2 rounded-md bg-red-100 text-red-700 hover:bg-red-200
                             dark:bg-red-900/40 dark:text-red-300 dark:hover:bg-red-800/60 transition-colors"
                  title="Delete"
                >
                  <FiTrash2 size={16} />
                </button>
              </>
            )}
          </div>
          </div>
        );
      })}
    </div>
  );
};

export default QuotationManagementTableMobile;
